enum TokenError {
    NotFound,
    Expired
}
export default TokenError;
